import { MouseEvent } from 'react';
import { sprintf } from 'sprintf-js';

import { Box } from 'components/Box';
import { Button } from 'components/Button/Button';
import { Divider } from 'components/Divider';
import { Hide } from 'components/Hide';
import { StyledNativeLinkWithRef } from 'components/Link/StyledNativeLinkWithRef';
import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE } from 'utils/constants/general/listingTypeHumanNameMapTitle';

import { orgHasListings } from './orgHasListings';

type Props = {
  org: ApiOrg;
  onClickOpportunities: (
    e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    analyticsProperties?: Record<string, unknown>,
  ) => void;
};

export function ViewOrgPageSidebarHeader({ org, onClickOpportunities }: Props) {
  const jobCount = org.jobs ? org.jobs.length : 0;
  const internshipCount = org.internships ? org.internships.length : 0;
  const volopCount = org.volops ? org.volops.length : 0;

  const hasListings = orgHasListings(org);

  return (
    <>
      {jobCount > 0 && (
        <Box mb={3}>
          <StyledNativeLinkWithRef
            href="#jobs"
            onClick={() =>
              trackClicked('See Opportunities', {
                type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.JOB} Link`,
              })
            }
          >
            {sprintf(
              jobCount > 1
                ? getText('%(jobCount)s current jobs')
                : getText('%(jobCount)s current job'),
              {
                jobCount,
              },
            )}
          </StyledNativeLinkWithRef>
        </Box>
      )}
      {internshipCount > 0 && (
        <Box mb={3}>
          <StyledNativeLinkWithRef
            href="#internships"
            onClick={() =>
              trackClicked('See Opportunities', {
                type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.INTERNSHIP} Link`,
              })
            }
          >
            {sprintf(
              internshipCount > 1
                ? getText('%(internshipCount)s current internships')
                : getText('%(internshipCount)s current internship'),
              {
                internshipCount,
              },
            )}
          </StyledNativeLinkWithRef>
        </Box>
      )}
      {volopCount > 0 && (
        <Box mb={3}>
          <StyledNativeLinkWithRef
            href="#volops"
            onClick={() =>
              trackClicked('See Opportunities', {
                type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.VOLOP} Link`,
              })
            }
          >
            {sprintf(
              volopCount > 1
                ? getText('%(volopCount)s current volunteer opportunities')
                : getText('%(volopCount)s current volunteer opportunity'),
              {
                volopCount,
              },
            )}
          </StyledNativeLinkWithRef>
        </Box>
      )}

      <Hide xs sm>
        {hasListings && (
          <Button
            type="link"
            onClick={(e) =>
              onClickOpportunities(e, {
                type: 'Button Left',
              })
            }
            href="#opportunities"
            variant="primary"
          >
            {getText('See opportunities')}
          </Button>
        )}
      </Hide>

      {jobCount > 0 || internshipCount > 0 || volopCount > 0 || hasListings ? (
        <Divider marginTop={24} marginBottom={24} />
      ) : null}
    </>
  );
}
